/**
 * @author Fernando Ruano
 * @file routes.js
 * @description Parameters routes
 */

// Pages
import ParametersCreation from '@nephro/pages/Parameters/ParametersCreation';
import ParametersViewEdit from '@nephro/pages/Parameters/ParametersViewEdit';
import ParametersManagement from '@nephro/pages/Parameters/ParametersManagement';

const pathStart = '/main/systems-parameters';
const routes = [
  {
    path: `${pathStart}/`,
    isProtected: true,
    component: ParametersManagement,
    exact: true
  },
  {
    path: `${pathStart}/create`,
    isProtected: true,
    component: ParametersCreation,
    exact: true
  },
  {
    path: `${pathStart}/view/:id`,
    isProtected: true,
    component: ParametersViewEdit,
    exact: true
  },
  {
    path: `${pathStart}/edit/:id`,
    isProtected: true,
    component: ParametersViewEdit,
    exact: true
  },
  { redirect: true, to: `${pathStart}/` }
];

export default routes;
